import { AdminClassroomLayout } from "@/pages/admin/AdminClassroomLayout";
import { ClassroomDetailPage } from "@/pages/teacher/ClassroomDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/classrooms/$classroomId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { classroomId } = Route.useParams();
  return (
    <AdminClassroomLayout>
      <ClassroomDetailPage classroomId={classroomId} scope="admin" />
    </AdminClassroomLayout>
  );
}
